<template>
    <div class="mobile-page">
        <div class="box"
             :style="{height:configData.heightConfig.val +'px',background:configData.bgColor.color[0].item}"></div>
    </div>
</template>

<script>
    export default {
        name: "blank",
        sort: 200,
        cname: '辅助空白',
        type: 2, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconfuzhukongbai1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        mounted() {

        },
        data() {
            return {
                defaultConfig: {
                    name: "blank",
                    cname: '辅助空白',
                    tabs: [
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        bgColor: {
                            title: '背景颜色',
                            tab: 0,
                            name: 'colors',
                            default: [{
                                item: '#f5f5f5'
                            }],
                            color: [
                                {
                                    item: '#f5f5f5'
                                }
                            ]
                        },
                        heightConfig: {
                            title: '组件高度',
                            tab: 0,
                            name: 'slider',
                            val: 10,
                            min: 1
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        height: 20px;
        background: #F5F5F5;
    }
</style>
